import { render } from "./ScrollingComponent.vue?vue&type=template&id=cfe345b0&scoped=true"
import script from "./ScrollingComponent.vue?vue&type=script&lang=js"
export * from "./ScrollingComponent.vue?vue&type=script&lang=js"

import "./ScrollingComponent.vue?vue&type=style&index=0&id=cfe345b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfe345b0"]])

export default __exports__